<template>
  <div class="upgrage-wrapper">
    <div class="upgrage-title">
      <template v-if="title && title.length">
        <div v-for="(item, index) in title" :key="index">
          {{ item }}
        </div>
      </template>
      <template v-else>
        H5版本暂不支持<br />
      请使用手机扫码，到小程序操作
      </template>
    </div>
    <div class="other-way">
      <p><span></span><span></span><span></span></p>
      <div>其他参与方式</div>
      <p><span></span><span></span><span></span></p>
    </div>
    <img
      class="quesQrcode"
      style="margin-top: 20px;"
      :src="src || 'http://xiaoxiaodati.com/static/media/xcx_qrcode.4bd584e0.jpeg'"
      alt=""
    />
    <div class="upgrag-tip">微信长按或扫码参与答题</div>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      value: ""
    },
    title: {
      type: Array,
      value: []
    }
  },
  data() {
    return {};
  },
  methods: {
    toAgreement() {
      this.$router.push({ name: "agreement" });
    },
    close() {
      this.$emit("hideVisible");
    },
    toFile() {
      this.$router.push({ name: "agreement" });
    }
  }
};
</script>

<style lang="scss" scoped>
.upgrage-wrapper {
  padding: 25px;
  font-size: 17px;
  text-align: center;
  color: #262626;
  .upgrage-title {
    line-height: 25px;
    margin-top: 15px;
  }
  .contact-btn {
    height: 43px;
    line-height: 43px;
    text-align: center;
    background: #1890ff;
    color: #fff;
    border-radius: 2px;
    font-size: 16px;
    margin: 20px auto;
  }
  .other-way {
    display: flex;
    color: #999999;
    align-items: center;
    justify-content: space-around;
    font-size: 14px;
    margin-top: 20px;
    div {
      margin: 0 4px;
    }
    p {
      // height: 1px;
      flex: 1;
      border-bottom: 1px dashed #999;
    }
  }
  .quesTitle {
    line-height: 21px;
    font-weight: 700;
    margin: 20px 0 15px;
  }
  .quesQrcode {
    width: 160px;
    height: 160px;
    object-fit: cover;
    margin: 0 auto 15px;
    display: block;
  }
  .upgrag-tip {
    display: inline-block;
    font-size: 14px;
    line-height: 21px;
    border: 1px dashed #ccc;
    padding: 6px 10px;
    color: #999;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/components/common/imgDialog.vue